module.exports = __webpack_public_path__ + "img/iconZhongNew.9016e8b6.png";